module.exports = __webpack_public_path__ + "img/CUFFMABI.90ee74ba.jpg";